import { Card, Group, Stack, Table, Text } from '@mantine/core'
import Message from '../../i18n/Message'

/**
 * Table at md and up, stacked cards below.
 * columns: [{ key, header (i18n key), render?(item), mobileHidden?, ref? }]
 */
export default function DataList({ items, columns, onRowClick, empty = 'empty_list', loading }) {
  if (!items || items.length === 0) {
    return (
      <Text c="dimmed" py="lg">
        <Message id={loading ? 'loading' : empty} />
      </Text>
    )
  }
  const cell = (col, item) => (col.render ? col.render(item) : item[col.key])
  return (
    <>
      <Table.ScrollContainer minWidth={640} visibleFrom="md">
        <Table highlightOnHover={!!onRowClick} verticalSpacing="sm">
          <Table.Thead>
            <Table.Tr>
              {columns.map((c) => (
                <Table.Th key={c.key}>
                  <Message id={c.header} />
                </Table.Th>
              ))}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {items.map((item) => (
              <Table.Tr key={item.id} onClick={onRowClick ? () => onRowClick(item) : undefined} style={onRowClick ? { cursor: 'pointer' } : undefined}>
                {columns.map((c) => (
                  <Table.Td key={c.key} ff={c.ref ? 'monospace' : undefined}>
                    {cell(c, item)}
                  </Table.Td>
                ))}
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
      <Stack gap="sm" hiddenFrom="md">
        {items.map((item) => (
          <Card key={item.id} onClick={onRowClick ? () => onRowClick(item) : undefined} style={onRowClick ? { cursor: 'pointer' } : undefined}>
            <Stack gap={6}>
              {columns
                .filter((c) => !c.mobileHidden)
                .map((c) => (
                  <Group key={c.key} justify="space-between" wrap="nowrap" align="flex-start">
                    <Text size="sm" c="dimmed">
                      <Message id={c.header} />
                    </Text>
                    <Text size="sm" ta="right" ff={c.ref ? 'monospace' : undefined} component="div">
                      {cell(c, item)}
                    </Text>
                  </Group>
                ))}
            </Stack>
          </Card>
        ))}
      </Stack>
    </>
  )
}
